export default __webpack_public_path__ + "80146ea9aa98b13c8e4474e858e22b46.svg";